import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'

const AUTO_SLIPPAGE = 0.5
const AUTO_SLIPPAGE_FIXED_RATE = 0.05
const MAX_SLIPPAGE = 10
export const SLIPPAGE_WARNING = 1

const CURRENT_VERSION = 2

interface SlippageSettings {
  // store value

  slippage: number // user setting slippage
  setSlippage: (v: number) => void
  isCustomSlippage: boolean
  setIsCustomSlippage: (v: boolean) => void

  slippageFixedRate: number // user setting slippage
  isCustomSlippageFixedRate: boolean
  setIsCustomSlippageFixedRate: (v: boolean) => void
  setSlippageFixedRate: (v: number) => void

  slippageBridge: number

  // ----------------

  // display value

  suggestSlippage: number // suggest by backend
  maxSlippage: number
  setSuggestSlippage: ({
    autoSlippage,
    maxSlippage,
    autoSlippageBridge,
  }: {
    autoSlippage: number | null | undefined
    maxSlippage: number | null | undefined
    autoSlippageBridge: number | null | undefined
  }) => void
}

const initializeData = {
  slippage: AUTO_SLIPPAGE,
  slippageFixedRate: AUTO_SLIPPAGE_FIXED_RATE,
  slippageBridge: AUTO_SLIPPAGE,

  suggestSlippage: AUTO_SLIPPAGE,
  isCustomSlippage: false,
  isCustomSlippageFixedRate: false,
  maxSlippage: MAX_SLIPPAGE,
}

export const useSlippageStore = create<SlippageSettings>()(
  persist(
    (set) => ({
      ...initializeData,
      setSlippage: (slippage) => set({ slippage: Math.min(slippage, MAX_SLIPPAGE) }),
      setSlippageFixedRate: (slippageFixedRate) =>
        set({ slippageFixedRate: Math.min(slippageFixedRate, MAX_SLIPPAGE) }),
      setSuggestSlippage: ({ autoSlippage, maxSlippage, autoSlippageBridge }) =>
        set((state) => {
          return {
            suggestSlippage: Math.min(autoSlippage ?? state.suggestSlippage ?? AUTO_SLIPPAGE, MAX_SLIPPAGE),
            maxSlippage: maxSlippage || MAX_SLIPPAGE,
            slippageBridge: autoSlippageBridge || AUTO_SLIPPAGE_FIXED_RATE,
          }
        }),
      setIsCustomSlippage: (isCustomSlippage) => set({ isCustomSlippage }),
      setIsCustomSlippageFixedRate: (isCustomSlippageFixedRate) => set({ isCustomSlippageFixedRate }),
    }),
    {
      name: 'slippage-store',
      version: CURRENT_VERSION,
      storage: createJSONStorage(() => localStorage),
    }
  )
)
